export default "__VITE_ASSET__Ckz6dv3d__"